import React from "react";
import FooterSection from "../../components/pages/home/footer-section";
import NavbarSection from "../../components/pages/home/navbar-section";
import BookCall from "../../components/common/book-call";
import PageMeta from "../../components/common/page-meta";
import AboutImage from "../../assets/images/projects/about/Main.png";
import {
  AboutCallout,
  AboutCalloutTitle,
  AboutCopy,
  AboutImageFrame,
  AboutLayout,
  AboutPage,
  AboutPortrait,
  AboutTitle,
} from "./style";

const About = () => (
  <AboutPage>
    <PageMeta
      title="About Freddy — Freddy's"
      description="About Freddy Albert Sanjaya, a visual designer and independent consultant."
    />
    <NavbarSection percentage={0} showLine={false} />
    <AboutLayout>
      <AboutPortrait>
        <AboutImageFrame src={AboutImage} alt="Freddy Albert Sanjaya" />
      </AboutPortrait>
      <AboutCopy>
        <AboutTitle>Hello there.</AboutTitle>
        <p>
          My full name is Freddy Albert Sanjaya, but you can call me Freddy. I
          am a Visual Communication Design graduate who has worked across
          product visuals, campaigns, checkout, and promotion experiences at
          Blibli and Traveloka.
        </p>
        <p>
          I tend to be the person who pauses and asks why something works the
          way it does, then steps back far enough to understand the larger
          pattern. That curiosity shapes how I approach design and how I think
          about work beyond a job title. I care about turning messy questions
          into thoughtful experiences that are useful to people.
        </p>
        <p>
          Today, I work independently as a Business &amp; Design Consultant and
          freelancer while pursuing a second degree at Institut Bisnis dan
          Informatika Kwik Kian Gie, connecting my design background with the
          business questions I navigate now.
        </p>
        <p>
          Earlier in my journey, I supported Inspiration Factory Foundation, a
          nonprofit focused on children’s education. It showed me that creative
          work can be useful to people beyond the brief.
        </p>
        <p>
          Outside work, I return to music, books, writing, and making
          illustrations whenever I feel like it. I spend a lot of time
          reflecting on life and noticing how people make sense of it
          differently.
        </p>
        <p>
          I have also been learning to take better care of myself through
          fitness. What started as an experiment has become a way to stay
          consistent and more attentive to how I feel. I share that journey
          on{" "}
          <a
            href="https://www.instagram.com/frediornot/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          .
        </p>
        <p>
          This website brings together my work, personal notes, and the things I
          am still figuring out. If you would like to collaborate, exchange
          ideas, or invite me to a session, write to{" "}
          <a href="mailto:freddy11sanjaya@gmail.com">
            freddy11sanjaya@gmail.com
          </a>
          .
        </p>
        <AboutCallout>
          <AboutCalloutTitle>
            Want to talk through a project or idea?
          </AboutCalloutTitle>
          <BookCall />
        </AboutCallout>
      </AboutCopy>
    </AboutLayout>
    <FooterSection />
  </AboutPage>
);

export default About;
